export default __webpack_public_path__ + "static/media/video.1623cb15.svg";